if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.sizeInputs = document.querySelectorAll('[name="Size"]');
        this.recipientFields = document.querySelectorAll(".recipient-fields");

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

        if (this.recipientFields) {
          Array.from(this.recipientFields).forEach((recipientField) => {
            const input =
              recipientField.querySelector("input") ||
              recipientField.querySelector("textarea");
            input.addEventListener("focus", () => {
              recipientField.classList.remove("error");
            });
          });
        }
        if (this.sizeInputs) {
          Array.from(this.sizeInputs).forEach((input) => {
            const isChecked = input.checked;
            const isAvailable = this.variantIsAvailable(input);
            if (isChecked && !isAvailable) {
              this.onUnavailableVariantSelected();
            }
            input.addEventListener("change", this.onVariantSelect.bind(this));
          });
        }
      }

      onUnavailableVariantSelected() {
        const event = new CustomEvent(
          window.FarmRio.events.selectedUnavailableVariant
        );
        document.dispatchEvent(event);
      }

      variantIsAvailable(input) {
        const availableQuantity = parseInt(input.dataset.availablequantity);
        return availableQuantity > 0;
      }

      onVariantSelect(event) {
        const isAvailable = this.variantIsAvailable(event.target);
        if (!isAvailable) this.onUnavailableVariantSelected();
        if (window.FarmRio.events.selectedProductVariant) {
          const selectedProductVariantEvent = new CustomEvent(
            window.FarmRio.events.selectedProductVariant,
            {
              detail: {
                variantName: event.target.value,
              },
            }
          );
          document.dispatchEvent(selectedProductVariantEvent);
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        if (submitButton.classList.contains("button--secondary")) {
          // const variantId = submitButton.dataset.variantId;
          // const backInStock = document.querySelector("back-in-stock");

          // backInStock.setVariantId(+variantId);
          // backInStock.openModal(evt);
          window._RestockRocket.openModal();

          return;
        }

        if (evt.target.closest(".is-float")) {
          document.dispatchEvent(
            new Event(
              window.FarmRio.events.addProductToCartFromFloatInformation
            )
          );
        }

        this.handleErrorMessage();
        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.remove(
          "hidden"
        );
        const isNewCart = !Boolean(window.getCookie("cart"));

        const formData = new FormData(this.form);
        const variant_id = formData.get("id");

        let properties = {};

        function extractKey(str) {
          const match = str.match(/\[(.*?)\]/);
          return match ? match[1] : null;
        }

        for (const [key, value] of formData.entries()) {
          if (key.startsWith("properties[")) {
            const _key = extractKey(key);
            properties[_key] = value;
          }
        }

        await Cart.addProductVariantToCart(Number(variant_id), 1, properties);

        if (isNewCart && window.FarmRio.events.createCart) {
          document.dispatchEvent(new Event(window.FarmRio.events.createCart));
        }

        submitButton.classList.remove("loading");
        submitButton.removeAttribute("aria-disabled");
        this.querySelector(".loading-overlay__spinner")?.classList.add(
          "hidden"
        );
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        const handleFieldErrorMessage = (message, field) => {
          if (!message || !field) return;
          const $wrapper = this.form.querySelector(
            `.recipient-fields__field.${field}`
          );
          if (!$wrapper) return;
          $wrapper.classList.add("error");
          const $errorWrapper = $wrapper.querySelector(`.form__message`);
          if (!$errorWrapper) return;
          $errorWrapper.classList.remove("hidden");
          const $errorMessageElement =
            $errorWrapper.querySelector(".error-message");
          if (!$errorMessageElement) return;
          $errorMessageElement.innerHTML = message;
        };

        if (typeof errorMessage === "string") {
          this.errorMessage.textContent = errorMessage;
        }

        if (
          errorMessage &&
          typeof errorMessage === "object" &&
          !Array.isArray(errorMessage)
        ) {
          const fields = Object.keys(errorMessage);

          const generalError = fields.reduce((acc, key) => {
            const fieldErrorMessage = errorMessage[key].join(". ");
            const specificErrorFields = ["send_on", "email"];
            if (specificErrorFields.includes(key)) {
              handleFieldErrorMessage(fieldErrorMessage, key);
              return acc;
            } else {
              return acc.concat(fieldErrorMessage);
            }
          }, "");

          if (generalError) {
            this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
            this.errorMessage.textContent = generalError;
          }
        }
      }
    }
  );
}
